import { render, staticRenderFns } from "./holes-grid-item.vue?vue&type=template&id=592ad223"
import script from "./holes-grid-item.vue?vue&type=script&lang=js"
export * from "./holes-grid-item.vue?vue&type=script&lang=js"
import style0 from "./holes-grid-item.vue?vue&type=style&index=0&id=592ad223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports